import PageLayout from '../../../../layout/dashboard/tableLayout';
import './styles/settlementIndex.css';
import DashboardLayout from '../../../../layout/dashboard/dashboardLayout';
import React, { useEffect, useState } from 'react';
import ravenlogo from '../../../../assets/raven-small-logo-green.svg'
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../redux/types';
import EmptyScreen from '../../../../components/common/emptyScreen';
import SmartFilter from '../../../../components/common/smartFilter';
import Pagination from '../../../../components/common/pagination';
import { settlementData } from './settlementData';
import { FaRegEye } from 'react-icons/fa';
import { icons } from '../../../../assets/icons';
import {
	capitalizeFirstLetter,
	capitalizeFirstWord,
	downloadCsvFile,
	formatDateHelper,
	formatMetaData,
	formatTypeFunction,
	getActionNamesByPolicyName,
	trimLongString,
} from '../../../../utils/helper/Helper';
import {
	RavenBadge,
	RavenModal,
	RavenNumberFormat,
	RavenTable,
	RavenTableRow,
} from '@ravenpay/raven-bank-ui';
import DateFragmentBox from '../../../../components/common/DateFragmentBox';
import TwoDetailView from '../../../../components/common/TwoDetailView';
import BadgeComponent from '../../../../components/common/badge/BadgeComponent';  
import EditFeeCategoryModal from '../fee-details/EditFeeCategoryModal';
import { bankboxAPI } from '../../../../redux/bankbox';
import { debounce } from 'lodash';
import ExportModal from '../../../../components/common/exportModal';
import ActionModal from '../../../../components/common/modal/ActionModal';
import InlineDetails from '../../../../components/common/inlineDetails';
import SettlementModal from '../users/newsingleuser/components/modal/settlementModal';
import ImageFragment from '../../../../components/common/ImageFragment';
import { stringify } from 'flatted';
import CheckUrlFragment from '../../../../components/common/CheckUrlCodeFragment';

const SettlementHistory = () => {
	const [showExport, setShowExport] = useState<boolean>(false);
	const { profile } = useSelector((state: RootState) => state.settings);
	const dispatch = useDispatch();
	const [currentPage, setCurrentPage] = useState(1);
	const [singleChild, setSingleChild] = useState<any>({});
	const { all_settlement, loading_settlement, banks } = useSelector(
		(state: RootState) => state.bankbox
	);

	// console.log('data', all_settlement);

	const [hasFetchedOnce, setHasFetchedOnce] = useState(false);

	useEffect(() => {  
		if (!loading_settlement && all_settlement?.data?.length > 0) {
			setHasFetchedOnce(true);
		}
	}, [loading_settlement, all_settlement]);

	// console.log(all_settlement);

	useEffect(() => {
		const obj = {
			per_page: 20,
			page: currentPage,
		};
		dispatch(bankboxAPI.getAllSettlements(obj));
	}, [currentPage]);
	// //(all_settlement);

	const csvHeader = [
		{ label: 'S/N', key: 'sn' },
		{ label: 'Business Name', key: 'merchant_name' },
		{ label: 'Business Email', key: 'merchant_email' },
		{ label: 'Type', key: 'type' },
		{ label: 'Amount', key: 'amount' },
		{ label: 'Account Name', key: 'account_name' },
		{ label: 'Account Number', key: 'account_number' },
		{ label: 'Bank', key: 'bank' },
		{ label: 'Transaction Reference', key: 'tranx_reference' },
		{ label: 'Transaction Details', key: 'transaction_details' },
		{ label: 'Date', key: 'created_at' },
		{ label: 'Status', key: 'status' },
	];

	// if (
	// 	!getActionNamesByPolicyName(
	// 		profile?.rolePolicies?.policies,
	// 		'settlement'
	// 	)?.includes('settlement')
	// ) {
	// 	return (
	// 		<DashboardLayout>
	// 			<>
	// 				<EmptyScreen
	// 					loading={Object?.keys(profile)?.length < 1 ? true : false}
	// 					title="Permission Denied"
	// 					subTitle="You have no permission to access this page, Please contact admin or support."
	// 				></EmptyScreen>
	// 			</>
	// 		</DashboardLayout>
	// 	);
	// }

	const [modalData, setModalData] = useState<any | null>(null);

	type showModalProp = {
		create: boolean;
		export: boolean;
		showdetails: boolean;
	};

	const [showModal, setShowModal] = useState<showModalProp>({
		create: false,
		export: false,
		showdetails: false,
	});

	const handleRowClick = (rowData: any) => {
		setModalData(rowData);
		setShowModal((prev) => ({
			...prev,
			showdetails: true,
		}));
	};

	const getStatusType = (status: string | number | undefined): string => {  
		const value = String(status);
		if (value === '1') return 'yellow';
		if (value === '2') return 'red';
		if (value === '3') return 'green';
		return 'default';
	};

	const getStatusText = (status: string | number | undefined): string => {
		const value = String(status);
		if (value === '1') return 'Pending';
		if (value === '2') return 'Failed';
		if (value === '3') return 'Successful';
		return 'Pending';
	};

	const getBankCode = (label: string) => {
		if (label) {
			const obj = banks?.find((chi?: any) => chi?.name === label);
			return obj;
		}
	};

	const bankIcon = (
		<svg
			className="img"
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M30.1895 14.9425C30.189 14.6126 30.1107 14.2874 29.961 13.9933C29.8114 13.6993 29.5945 13.4446 29.328 13.25L19.622 6.16453C19.2682 5.90658 18.8426 5.76569 18.4047 5.76157C17.9669 5.75744 17.5387 5.89029 17.18 6.14153L7.04452 13.25C6.76854 13.4435 6.54318 13.7006 6.38749 13.9995C6.2318 14.2985 6.15035 14.6305 6.15002 14.9675C6.14996 15.0782 6.1717 15.1878 6.21401 15.2901C6.25632 15.3924 6.31837 15.4853 6.39661 15.5636C6.47485 15.6419 6.56775 15.704 6.67 15.7464C6.77225 15.7887 6.88184 15.8105 6.99252 15.8105H29.322C29.436 15.8105 29.5488 15.7881 29.6541 15.7445C29.7594 15.7008 29.8551 15.6369 29.9356 15.5563C30.0162 15.4757 30.0801 15.38 30.1236 15.2747C30.1672 15.1694 30.1896 15.0565 30.1895 14.9425Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M6.15002 27.1804V28.2804C6.15002 28.8374 6.37127 29.3715 6.7651 29.7653C7.15893 30.1592 7.69307 30.3804 8.25002 30.3804H28.0915C28.6485 30.3804 29.1826 30.1592 29.5764 29.7653C29.9703 29.3715 30.1915 28.8374 30.1915 28.2804V27.1804H6.15002Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M18.6415 16.6289H17.6995C17.0017 16.6289 16.436 17.1946 16.436 17.8924V25.0569C16.436 25.7547 17.0017 26.3204 17.6995 26.3204H18.6415C19.3393 26.3204 19.905 25.7547 19.905 25.0569V17.8924C19.905 17.1946 19.3393 16.6289 18.6415 16.6289Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M25.5335 16.6289H24.5915C23.8937 16.6289 23.328 17.1946 23.328 17.8924V25.0569C23.328 25.7547 23.8937 26.3204 24.5915 26.3204H25.5335C26.2313 26.3204 26.797 25.7547 26.797 25.0569V17.8924C26.797 17.1946 26.2313 16.6289 25.5335 16.6289Z"
				fill="var(--primary-base-color)"
			/>
			<path
				d="M11.7494 16.6289H10.8074C10.1096 16.6289 9.54395 17.1946 9.54395 17.8924V25.0569C9.54395 25.7547 10.1096 26.3204 10.8074 26.3204H11.7494C12.4473 26.3204 13.0129 25.7547 13.0129 25.0569V17.8924C13.0129 17.1946 12.4473 16.6289 11.7494 16.6289Z"
				fill="var(--primary-base-color)"
			/>
		</svg>
	);

	return (
		<>
			<DashboardLayout>
				<PageLayout
					pageSubtitle="View settlement history with merchants"
					pageTitle="Settlement Transations"
					topRightContent={<></>}
				>
					<div className="input_filter_export_general_wrap">
						<SmartFilter
							// hideFilter
							//  hideExport
							searchTitle="Search settlements"
							defaultFilterBy="status"
							onSearchChange={debounce((e) => {
								if (String(e)?.length > 0) {
									dispatch(
										bankboxAPI.getAllSettlementSearch({
											per_page: 20,
											page: currentPage,
											search: e,
										})
									);
								} else {
									dispatch(
										bankboxAPI.getAllSettlements({
											per_page: 20,
											page: currentPage,
										})
									);
								}
							}, 500)}
							filters={[
								{
									label: 'Status',
									filterBy: 'status',
									options: [
										{
											label: 'Pending',
											value: '1',
										},
										{
											label: 'Failed',
											value: '2',
										},
										{
											label: 'Successful',
											value: '3',
										},
										{
											label: 'All Status',
											value: 'reset',
										},
									],
								},
							]}
							onExport={() => {
								setShowExport(true);
							}}
							page="bankbox_settlements"
							// onSearchChange={debounce((e) => {
							// 	dispatch(
							// 		bankboxAPI.getAllFees({
							// 			per_page: 20,
							// 			page: currentPage,
							// 			search: e,
							// 		})
							// 	);
							// }, 500)}
						/>

						<div className="pagination-wrap">
							{' '}
							<Pagination
								className="top-bar__pagination"
								currentPage={currentPage}
								itemsPerPage={all_settlement?.pagination?.perPage}
								totalItems={all_settlement?.pagination?.total}
								onPageChange={function (page: number): void {
									setCurrentPage(page);
								}}
							/>
						</div>
					</div>

					<div className="fee-detail-dashboard-content-index-wrap">
						{!hasFetchedOnce && loading_settlement ? (
							<EmptyScreen
								loading
								loadingText="Loading Settlement..."
								title="Loading..."
								subTitle="Please wait while we fetch your settlement history."
							/>
						) : all_settlement.data?.length < 1 ? (
							<EmptyScreen
								loading={false}
								title="No Settlement History Found"
								subTitle="You don't have any record yet, your new bankbox transactions will be displayed here."
							/>
						) : (
							<div className="transaction__table non-mobile">
								<RavenTable
									action={false}
									className="table__main"
									headerList={[
										'MERCHANT',
										'BANK DETAILS',
										'TYPE',
										'AMOUNT',
										'DATE',
										'STATUS',
									]}
								>
									{all_settlement?.data?.map((chi: any, idx: any) => {
										const bank_code = getBankCode(
											chi?.account_details?.bank
										)?.code;

										// console.log(chi)

										// const meta = JSON.parse(chi.meta_data);
										// if (chi?.type !== 'merchant_wallet_transfer') {
										// 	return <React.Fragment key={idx}></React.Fragment>;
										// }
										return (
											<RavenTableRow
												loading={loading_settlement}
												onRowClick={() => {
													handleRowClick(chi);

													// console.log(chi?.account_details);
												}}
												key={idx}
												one={
													<TwoDetailView
														title={
															trimLongString(
																capitalizeFirstWord(
																	chi?.business_profile?.business_name
																),
																25
															) || '----'
														}
														text_one={trimLongString(
															chi?.business_profile?.email,
															30
														)}
													/>
												}
												two={
													<>
														<div className="flex_bank_code">
															<CheckUrlFragment
																className="icon-wrap card-bg border-theme"
																url={
																	chi?.type === 'merchant_wallet_transfer'
																		? `https://businessapi.getraventest.com/static/media/banks/${
																				formatMetaData(chi?.meta_data)
																					?.bank_code || 'default-bank'
																		  }.png`
																		: chi?.type === 'card'
																		? `https://businessapi.getraventest.com/static/media/banks/${
																				bank_code || 'default-bank'
																		  }.png`
																		: chi?.type === 'bank_collection'
																		? `https://businessapi.getraventest.com/static/media/banks/${
																				bank_code || 'default-bank'
																		  }.png`
																		: 'https://businessapi.getraventest.com/static/media/banks/default-bank.png'
																}
															>
																{(() => {
																	const code =
																		chi?.type === 'merchant_wallet_transfer'
																			? formatMetaData(chi?.meta_data)
																					?.bank_code
																			: chi?.type === 'card' ||
																			  chi?.type === 'bank_collection'
																			? bank_code
																			: null;

																	return code === '090615' ? (
																		<figure className="img-box-bank-card-logo">
																			<img
																				src={ravenlogo}
																				alt=""
																				className="img"
																			/>
																		</figure>
																	) : (
																		<figure className="img-box-bank-card-logo border-theme">
																			{bankIcon}
																		</figure>
																	);
																})()}
															</CheckUrlFragment>

															<TwoDetailView
																title={
																	capitalizeFirstWord(
																		trimLongString(
																			chi?.account_details?.account_name,
																			25
																		) as any
																	) || '----'
																}
																text_one={
																	formatMetaData(chi?.meta_data)?.bank ??
																	chi?.account_details?.bank ??
																	'---'
																}
																text_two={
																	chi?.account_details?.account_number || '---'
																}
															/>
														</div>
													</>
												}
												three={
													trimLongString(formatTypeFunction(chi?.type), 25) ||
													''
												}
												four={RavenNumberFormat(chi?.amount)}
												five={<DateFragmentBox date={chi?.created_at} />}
												six={
													<RavenBadge
														text={getStatusText(chi?.status)}
														type={getStatusType(chi?.status)}
													/>
												}
											/>
										);
									})}
								</RavenTable>
							</div>
						)}
					</div>
				</PageLayout>
			</DashboardLayout>

			<SettlementModal
				// buttonColor={''}
				trx_ref={modalData?.trx_ref}
				singleObj={modalData}
				isLoadingDetails={true}
				reference={modalData?.reference || '---'}
				transactionType={modalData?.type || '---'}
				amount={modalData?.amount || '---'}
				account_name={modalData?.account_details?.account_name || '---'}
				accountNumber={modalData?.account_details?.account_number || '---'}
				bank={
					formatMetaData(modalData?.meta_data)?.bank ??
					modalData?.account_details?.bank ??
					'---'
				}
				type={modalData?.type || '---'}
				status={
					<RavenBadge
						text={getStatusText(modalData?.status)}
						type={getStatusType(modalData?.status)}
					/>
				}
				date={new Date(modalData?.created_at || '---')}
				onClose={() => {
					setShowModal((prev) => ({
						...prev,
						showdetails: false,
					}));
				}}
				visible={showModal?.showdetails}
				singleChild={singleChild}
			/>

			<ExportModal
				onClose={() => setShowExport(false)}
				visible={showExport}
				page="bankbox_settlements"
				onFinishExport={(param) => {
					// //(param);

					// formatExportData(param);
					window.open(param, '_blank')?.focus();
				}}
				loading={loading_settlement}
			/>
		</>
	);
};
export default SettlementHistory;
